<script setup>
import LinkInline from "@/Components/LinkInline.vue";

defineProps({
    learnings: Array,
});
</script>

<template>
    <div id="learning-section" class="mt-32 sm:mt-56">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl sm:text-center">
                <h2
                    class="text-base/7 font-semibold text-brand-dark dark:text-brand-accent"
                >
                    <slot name="subtitle"></slot>
                </h2>
                <p
                    class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 dark:text-gray-100 sm:text-balance sm:text-5xl"
                >
                    <slot name="title"></slot>
                </p>
                <p class="mt-6 text-lg/8 text-gray-600 dark:text-gray-300">
                    <slot name="description"></slot>
                </p>
            </div>
        </div>
        <div class="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
            <dl
                class="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base/7 text-gray-600 dark:text-gray-300 sm:grid-cols-2 lg:mx-0 lg:grid-cols-3 lg:max-w-none lg:gap-x-8 lg:gap-y-16"
            >
                <template v-for="learning in learnings" :key="learning.name">
                    <div
                        class="flex flex-col h-full justify-between col-span-full sm:col-span-1"
                    >
                        <div>
                            <dt
                                class="flex flex-row items-center font-semibold text-gray-900 dark:text-gray-100"
                            >
                                <faIcon
                                    :icon="learning.icon"
                                    class="mr-2 size-4! text-brand-dark dark:text-brand-accent"
                                    aria-hidden="true"
                                />
                                {{ learning.name }}
                            </dt>
                            <dd class="mt-2">{{ learning.description }}</dd>
                        </div>
                        <dd
                            class="flex flex-row items-center dark:text-gray-100 mt-auto pt-4"
                        >
                            <LinkInline as="a" :href="learning.url">
                                Learn More &rarr;
                            </LinkInline>
                        </dd>
                    </div>
                </template>
            </dl>
        </div>
    </div>
</template>
